export default __webpack_public_path__ + "static/media/Hydrophilic.d8c5f9ec.jpg";